module.exports = __webpack_public_path__ + "static/IMG_4240-4ca330c092bd59a2673c39c5a7fcb9ee.jpeg";